/**
 * orga-app-api - displaysteuerung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Rolle { 
    titel?: string;
    funktionsbereich_id?: string;
    rolle_id?: string;
    anzahl_benutzer?: number;
    mandant_id?: string;
    modified_on_utc?: Date;
}

